export default "__VITE_ASSET__CK7u98ut__"